import { Page } from 'components/layout';
import Tabs, { Tab, TabPanel } from '@ingka/tabs';
import Text from '@ingka/text';
import React from 'react';
import Search from '@ingka/search';
import styled from 'styled-components';
import { contentDelimiterStyles } from 'components/layout';
import { DataTable } from 'components/common/DataTable';

const FileUpload = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  ${contentDelimiterStyles};
`;

const supplierTableColumnConfig = [
  {
    header: 'Supplier',
    columns: [
      {
        header: 'Commodity',
        accessorKey: 'commodity',
      },
      {
        header: 'Country',
        accessorKey: 'country',
      },
      {
        header: 'DDS status',
        accessorKey: 'ddsstatus',
      },
      {
        header: 'Reference number',
        accessorKey: 'referencenumber',
      },
    ],
  },
];

const suppliers = {
  data: [
    {
      commodity: 'Coffee',
      country: 'sweden',
      ddsstatus: 'available',
      referencenumber: '120',
    },
    {
      commodity: 'Coffee',
      country: 'sweden',
      ddsstatus: 'available',
      referencenumber: '121',
    },
    {
      commodity: 'Coffee',
      country: 'sweden',
      ddsstatus: 'not available',
      referencenumber: '123',
    },
    {
      commodity: 'Coffee',
      country: 'as',
      ddsstatus: 'available',
      referencenumber: '124',
    },
  ],
};
// const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
//   const searchTerm = e.target.value.toLowerCase();
//   const filteredData = suppliers.data.filter(item =>
// item.name.toLowerCase().includes(searchTerm) ||
//     item.category.toLowerCase().includes(searchTerm)
//   );

//   console.log(filteredData); // Do whatever you want with the filtered data
// };
export const DetailPage = () => {
  const tabs = [
    <Tab key="tab-3" text={'Pending Approval'} tabPanelId="tab_3" />,
    <Tab key="tab-4" text={'Saved for later'} tabPanelId="tab_4" />,
    <Tab key="tab-5" text={'Submitted to EU registry'} tabPanelId="tab_5" />,
    <Tab key="tab-6" text={'Archived'} tabPanelId="tab_6" />,
  ];

  const tabPanels = [
    <TabPanel key="tab-3" tabPanelId="tab_3">
      <DataTable columns={supplierTableColumnConfig} data={suppliers.data} />;
    </TabPanel>,
    <TabPanel key="tab-4" tabPanelId="tab_4">
      <Page>Hi all</Page>;
    </TabPanel>,
    <TabPanel key="tab-5" tabPanelId="tab_5">
      <Page>welcome</Page>;
    </TabPanel>,
    <TabPanel key="tab-6" tabPanelId="tab_6">
      <Page>people</Page>;
    </TabPanel>,
  ];

  return (
    <Page>
      <FileUpload>
        <Text headingSize="xl" tagName="h1">
          FEDSA
        </Text>
        <Search
          ariaLabel="Search for product categories, product names, etc."
          clearBtnText="Clear search field"
          id="search"
          // onSearch={(e)=> {onSearch}}
          placeholder="Search"
          scope={{
            All: 'All',
            Deals: 'Deals',
          }}
          scopeSelectProps={{
            onChange: function noRefCheck() {},
          }}
          submitBtnText="Submit"
        />
      </FileUpload>
      <div>
        <Tabs
          tabs={tabs}
          tabPanels={tabPanels}
          defaultActiveTab="tab_3"
          ariaLabel="Example Tabs Label"
        />
      </div>
    </Page>
  );
};
